import { render, staticRenderFns } from "./TopRanksListItem.vue?vue&type=template&id=08d449d5&scoped=true&"
import script from "./TopRanksListItem.vue?vue&type=script&lang=js&"
export * from "./TopRanksListItem.vue?vue&type=script&lang=js&"
import style0 from "./TopRanksListItem.vue?vue&type=style&index=0&id=08d449d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d449d5",
  null
  
)

export default component.exports